module.exports = __webpack_public_path__ + "img/weather.19b40224.png";